
import { MediaObserver } from '@angular/flex-layout';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { ViewEncapsulation } from '@angular/core';
import { LoggerService } from '../logger/logger.service';
import { NavigationService } from './navigation.service';
import { AuthenticationService } from '@app/auth/authentication.service';
import { OrganizationsService } from './organizations.service';

const log = new LoggerService('NAVIGATION COMPONENT');

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class NavigationComponent implements OnInit {

  private logotypes = {
    epione: {
      colors: 'https://epione-image.s3.us-east-2.amazonaws.com/epione/logo_epione_colors.png',
      shadow: 'https://epione-image.s3.us-east-2.amazonaws.com/epione/logo_epione_colors_shadow.png',
      white: '',
    }
  }

  private userData: any = {
    name: '',
    email: ''
  }
  public isLoading: boolean = true;

  public sidebarLogo: string;
  public toolbarLogo: string;
  public toolbarLink: string;
  public acordionsEnabled: boolean = false;

  public navigationRoutes: Navigation.NavigationDataRoute[] = [];
  public navigationData: Navigation.NavigationData[] = [];
  public organizationsData: Entities.Organization.OrganizationData[] = [];

  public currentRoute: string;



  get username(): string | null {
    return null;
  }

  get isMobile(): boolean {
    return this.media.isActive('xs') || this.media.isActive('sm') || this.media.isActive('md');
  }

  constructor(
    private router: Router,
    private media: MediaObserver,
    private navigationService: NavigationService,
    private authenticationService: AuthenticationService,
    private organizationService: OrganizationsService
  ) { }

  async ngOnInit() {
    this.setInstanceConfiguration();
    await this.setNavigationRoutes();

    this.setRouterListeners();
    this.isLoading = false;
  }


  /**
   * @description Busca el logotipo de la organización a la que pertenece la ruta.
   * @param routePath 
   * @returns 
   */
  private findOrgLogoWithRoute(routePath: string) {

    const splittedPath = routePath.substring(1).split('/');
    const parentPath = `${splittedPath[0]}${splittedPath[1] ? '/' + splittedPath[1] : ''}`;
    //log.debug('[findOrgLogoWithRoute] splittedPath: ', splittedPath);
    //log.debug('[findOrgLogoWithRoute] parentPath: ', parentPath);



    for (let x = 0; x < this.navigationData.length; x++) {
      //log.debug('[findOrgLogoWithRoute] navigationData:', this.navigationData[x]);
      for (let i = 0; i < this.navigationData[x].routes.length; i++) {
        //log.debug('[findOrgLogoWithRoute] route path:', this.navigationData[x].routes[i].path);

        if (parentPath === this.navigationData[x].routes[i].path) {
          return this.navigationData[x].logo;
        }
      }
    }
  }


  /**
   * @description Configura el event listeners de cambios en el router. Listener utiliado para asignar el logo de la organización.
   */
  private setRouterListeners() {
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        // Show progress spinner or progress bar
        //log.debug('[setRouterListeners] Route change detected: ', event);
        this.toolbarLogo = this.findOrgLogoWithRoute(event.url);
        //log.debug('[setRouterListeners] toolbarLogo: ', this.toolbarLogo);
      }
    });
  }


  /**
   * @description Configura todos los datos necewsarios para el correcto funcionamiento de la instancia. Se ejecuta al inicar el componente.
   */
  private setInstanceConfiguration(): void {
    this.sidebarLogo = this.logotypes['epione']['shadow'];
    if (!this.toolbarLogo)
      this.toolbarLogo = 'https://epione-image.s3.us-east-2.amazonaws.com/epione/logo_dohealth_white.png';
    this.toolbarLink = 'http://www.dohealth.com.mx/';
    this.userData = this.authenticationService.userData;
  }

  /**
   * @description Revisa si los datos de navegación incluyen el microfrontend epione general
   * @param navData 
   * @returns boolean
   */
  private hasEpioneGeneralRoutes(navData: Navigation.NavigationData[]) {
    for (let x = 0; x < navData.length; x++) {
      if (navData[x].remoteEntry === 'MF_EPIONE_GENERAL')
        return true;
    }
    return false;
  }

  /**
   * @description Declara las rutas de navegación para su uso en la interfaz de usuario.
   */
  private async setNavigationRoutes() {
    await this.navigationService.startupNavigationService({ isLoggedIn: await this.authenticationService.isLoggedIn() });
    //this.router.resetConfig(routes);
    const data = this.navigationService.navigationData;

    //log.debug('[setNavigationRoutes] Setting nav routes on nav component. ', data);

    if (data.length === 1) {
      this.acordionsEnabled = false;
      this.navigationData = data;
      this.navigationRoutes = data[0].routes;
    }

    if (data.length === 2) {

      if (this.hasEpioneGeneralRoutes(data)) {
        this.acordionsEnabled = false;
        this.navigationData = data;
        this.navigationRoutes = [...data[0].routes, ...data[1].routes];
      } else {

        this.acordionsEnabled = true;
        this.navigationData = data;
      }

    }

    if (data.length > 2) {
      this.acordionsEnabled = true;
      this.navigationData = data;
      /*
      for (let i = 0; i < data.length; i++){
        this.navigationRoutes = [ ...this.navigationRoutes, ...data[i].routes]
      }}*/
    }

    //log.debug('[setNavigationRoutes] navigationData: ', this.navigationData)
    //log.debug('toolbarlogo: ', this.toolbarLogo)
  }


  public routeBtnClick(route: Navigation.NavigationData, navDataIndex?: number) {
    //log.debug('Clicked new route: ', route);
    //log.debug('navDataIndex: ', navDataIndex);
    //log.debug('navigationData: ', this.navigationData);
    //log.debug('navigationRoutes: ', this.navigationRoutes);

    if (navDataIndex !== null && navDataIndex !== undefined && navDataIndex) {
      //log.debug('Nav data ', this.navigationData[navDataIndex]);
      this.toolbarLogo = this.navigationData[navDataIndex].logo;
    } else {

      this.toolbarLogo = this.navigationData[0].logo;
    }
  }

  /**
   * @description Manda a llamar al servicio de autenticación para realizar el cierre de sesión del usuario.
   */
  public async logout() {
    try {
      this.isLoading = true;
      const logOutCompleted = await this.authenticationService.logOut();
      if (logOutCompleted) {
        this.router.navigate(['/home']);
        this.isLoading = false;
      }
    }
    catch (err) {
      throw err;
    }
  }

  /**
   * @description Copia el nombre del usuario.
   */
  public copyUserName(): void {
    const dummyInput = document.createElement('input');
    //log.debug('Copying username: ', this.userData.name);
    dummyInput.value = this.userData.name;
    document.body.appendChild(dummyInput);
    dummyInput.select();
    dummyInput.setSelectionRange(0, 99999);
    document.execCommand('Copy');
    dummyInput.remove();
  }

  /**
   * @description Copia el nombre del usuario.
   */
  public copyUserEmail(): void {
    const dummyInput = document.createElement('input');
    //log.debug('Copying username: ', this.userData.email);
    dummyInput.value = this.userData.email;
    document.body.appendChild(dummyInput);
    dummyInput.select();
    dummyInput.setSelectionRange(0, 99999);
    document.execCommand('Copy');
    dummyInput.remove();
  }



}

